<template>
    <div id="yuandan">
        <div class="box">
            <div class="price">
                <h1>充值18元+<span>得36元</span></h1>
                <p>原1800书币，现加送1800书豆，共得3600阅读币</p>
            </div>
            <button @click="doRecharge">立即充值</button>
        </div>

        <div class="tip">

            <p>书币属于虚拟商品，一经购买不得退换;</p>
            <p>活动最终解释权归网站所有.</p>
            <p>活动截止时间：2021-01-03</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Yuandan",
        data(){
            return {
                active:63,
            }
        },methods:{
            doRecharge(){

                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 19,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#yuandan{padding:800px 40px 40px 40px;min-height:100%;background-color:#f55145;background-image: url("http://static.yuread.cn/quick/yd.jpg");background-size:100% ;background-repeat:no-repeat;overflow: auto;
    .box{background: #fff;border-radius: 42px;padding:58px 32px;
        .price{width: 100%;height: 208px;background-image: url("http://static.yuread.cn/quick/q2.png");background-size: 100%;padding-top: 42px;
            h1{font-size: 52px;font-weight: 400;text-align: center;
                span{color: #E6273B;}
            }

            p{font-size: 24px;text-align: center;margin-top: 20px;}

        }
        button{width: 100%;height: 102px;border-radius: 51px;color: #fff;border:none;background-color:#E6293B; font-size: 36px;margin-top: 58px;}

    }
    .tip{margin-top: 76px;
        p{text-align: center;color: #fff;font-size: 24px;}
    }

    .type{
        background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
        ul{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
            li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
            .wechat{background-color: #32BE1B;}
            .zfb{background-color: #1296db;}
            img{width: 34px;height:34px;position: relative;top:5px;}
        }
    }
}
</style>
